import { Group } from "@mantine/core"

import type { LibraryResponses } from "@tfg/types/endpoints/library"

import { CustomFieldMaterialsColumn } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldMaterialsColumn"
import { CustomFieldTreeBranch } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldTreeBranch"
import { HorizontalDivider } from "~/pages/Brand/Products/Details/CustomFieldGraph/Divider.tsx"
import type { GetItemOperations } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.types"
import { getCustomFieldDefinitionsForItem } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.utils"

type Props = {
  readonly component: LibraryResponses.EnrichedComponent
  readonly product: LibraryResponses.ProductDetails
  readonly productActivityIds: readonly string[]
  readonly getOperations: GetItemOperations
}

export const CustomFieldComponentRow = ({
  component,
  product,
  productActivityIds,
  getOperations,
}: Props) => {
  return (
    <Group gap={0} align="flex-start" wrap="nowrap">
      <CustomFieldTreeBranch
        customFieldsDefs={getCustomFieldDefinitionsForItem(
          product,
          component.item,
          productActivityIds
        )}
        item={component.item}
        operations={getOperations(component.item)}
      />
      {component.materials.length > 0 && <HorizontalDivider />}
      <CustomFieldMaterialsColumn
        materials={component.materials}
        product={product}
        productActivityIds={productActivityIds}
        getOperations={getOperations}
      />
    </Group>
  )
}
